import { create } from 'zustand';
import type { RevealState } from './useRevealController';

interface RevealStore {
  enabled: boolean;
  state: RevealState;
  open: () => void;
  close: () => void;
  sync: (patch: Partial<Pick<RevealStore, 'enabled' | 'state' | 'open' | 'close'>>) => void;
}

const noop = () => {};

export const useRevealStore = create<RevealStore>((set) => ({
  enabled: false,
  state: 'collapsed',
  open: noop,
  close: noop,
  sync: (patch) => set(patch),
}));
